import { useState } from 'react';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';

const Faq: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Faq');
    const [expandedItems, setExpandedItems] = useState<number[]>([]);

    const content = [
        {
            title: t('item_title1'),
            content: t('item_content1'),
        },
        {
            title: t('item_title2'),
            content: t('item_content2'),
        },
        {
            title: t('item_title3'),
            content: t('item_content3'),
        },
        {
            title: t('item_title4'),
            content: t('item_content4'),
        },
        {
            title: t('item_title5'),
            content: t('item_content5'),
        },
    ];

    const toggleItem = (index: number) => {
        setExpandedItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]));
    };

    return (
        <div className={styles.Faq + ' GtmModuleData-section'} data-section-id="faq">
            <div className="lp-layout faq-content">
                <div className="title">FAQ</div>

                <div className="content">
                    {content.map((item, index) => (
                        <div className="content-item" key={item.title}>
                            <div className={`content-item-title ${expandedItems.includes(index) ? 'expanded' : ''}`} onClick={() => toggleItem(index)}>
                                <span className="arrow">▼</span>
                                {item.title}
                            </div>
                            <div className={`content-item-content ${expandedItems.includes(index) ? 'expanded' : ''}`}>{item.content}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Faq;
